var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 1.78125C16.6875 1.875 17 2.25 17 2.71875C17 10.625 10.5625 17 2.6875 17C2.21875 17 1.84375 16.6875 1.75 16.25L1 13.0938C0.90625 12.6562 1.15625 12.1875 1.5625 12L4.96875 10.5312C5.375 10.375 5.84375 10.4688 6.09375 10.8125L7.46875 12.5C9.65625 11.4375 11.4062 9.6875 12.4688 7.5L10.7812 6.125C10.4375 5.875 10.3438 5.40625 10.5 5L11.9688 1.59375C12.1562 1.15625 12.625 0.9375 13.0938 1.03125L16.2188 1.78125ZM2.71875 16C10.0312 16 15.9688 10.0625 15.9688 2.75L12.875 2.03125L11.4375 5.375L13.7188 7.25C12.1875 10.4688 10.4375 12.2188 7.21875 13.75L5.34375 11.4688L2 12.9062L2.71875 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.01bc9c51b55965c9aef1189049614e32.svg";
export { ForwardRef as ReactComponent };